module.exports = __webpack_public_path__ + "static/media/project-image-8.f58119e1.jpg";